import React from "react";
import { Table, Button, Space, Popconfirm, Tag, Empty, Card } from "antd";
import { EditOutlined, DeleteOutlined, CalendarOutlined, ClockCircleOutlined } from "@ant-design/icons";
import AircraftTag from "../../../components/AircraftTag";
import dayjs from "dayjs";

/**
 * 已配置飞机列表组件
 * 显示所有已录入的飞机配置
 */
const AircraftConfigList = ({ 
    dataSource = [], 
    loading = false, 
    onEdit, 
    onDelete 
}) => {
    const columns = [
        {
            title: "飞机注册号",
            dataIndex: "aircraft_registration",
            key: "aircraft_registration",
            width: 180,
            render: (registration) => (
                <AircraftTag registration={registration} showType={true} />
            ),
        },
        {
            title: "年计划运行小时",
            dataIndex: "planned_hours",
            key: "planned_hours",
            width: 180,
            render: (hours) => (
                <Space>
                    <ClockCircleOutlined style={{ color: "#1890ff" }} />
                    <span style={{ fontWeight: 500 }}>{hours?.toLocaleString()}</span>
                    <span style={{ color: "#999" }}>小时</span>
                </Space>
            ),
        },
        {
            title: "下一次检查日期",
            dataIndex: "next_inspection_date",
            key: "next_inspection_date",
            width: 200,
            render: (date) => {
                const inspectionDate = dayjs(date);
                const today = dayjs();
                const daysUntil = inspectionDate.diff(today, "day");
                
                // 根据距离检查日期的天数显示不同颜色
                let color = "blue";
                let status = "";
                if (daysUntil < 0) {
                    color = "red";
                    status = "已逾期";
                } else if (daysUntil <= 30) {
                    color = "orange";
                    status = `还有${daysUntil}天`;
                } else if (daysUntil <= 90) {
                    color = "gold";
                    status = `还有${daysUntil}天`;
                } else {
                    color = "green";
                    status = `还有${daysUntil}天`;
                }

                return (
                    <Space>
                        <CalendarOutlined style={{ color }} />
                        <span>{inspectionDate.format("YYYY-MM-DD")}</span>
                        <Tag color={color}>{status}</Tag>
                    </Space>
                );
            },
        },
        {
            title: "最后更新时间",
            dataIndex: "updated_at",
            key: "updated_at",
            width: 180,
            render: (time) => time ? dayjs(time).format("YYYY-MM-DD HH:mm") : "-",
        },
        {
            title: "操作",
            key: "action",
            width: 150,
            fixed: "right",
            render: (_, record) => (
                <Space size="small">
                    <Button
                        type="link"
                        size="small"
                        icon={<EditOutlined />}
                        onClick={() => onEdit && onEdit(record)}
                    >
                        编辑
                    </Button>
                    <Popconfirm
                        title="确认删除"
                        description={`确定要删除飞机 ${record.aircraft_registration} 的配置吗？`}
                        onConfirm={() => onDelete && onDelete(record)}
                        okText="确定"
                        cancelText="取消"
                    >
                        <Button
                            type="link"
                            size="small"
                            danger
                            icon={<DeleteOutlined />}
                        >
                            删除
                        </Button>
                    </Popconfirm>
                </Space>
            ),
        },
    ];

    return (
        <Card 
            title={`已配置飞机（${dataSource.length}架）`}
            size="small"
        >
            <Table
                columns={columns}
                dataSource={dataSource}
                loading={loading}
                rowKey="id"
                pagination={false}
                size="small"
                locale={{
                    emptyText: (
                        <Empty
                            image={Empty.PRESENTED_IMAGE_SIMPLE}
                            description={
                                <div>
                                    <p style={{ marginBottom: 8 }}>暂无配置数据</p>
                                    <p style={{ color: "#999", fontSize: 12 }}>
                                        请在上方表单中选择飞机并录入配置信息
                                    </p>
                                </div>
                            }
                        />
                    ),
                }}
            />
        </Card>
    );
};

export default AircraftConfigList;


